import { Leaf, Cpu, Package } from 'lucide-react';

const PrintingTech = () => {
  const technologies = [
    {
      icon: Leaf,
      title: 'Eco-Friendly Production',
      description:
        'We use water-based, eco-friendly inks and sustainable packaging. Our on-demand model minimizes waste by only producing what\'s ordered.',
    },
    {
      icon: Cpu,
      title: 'Advanced DTG Printing',
      description:
        'Industry-leading Brother and Kornit machines deliver vibrant, long-lasting prints with exceptional detail and color accuracy.',
    },
    {
      icon: Package,
      title: 'Precision Packaging',
      description:
        'Automated folding and bagging systems ensure every order is impeccably packaged with care and efficiency.',
    },
  ];

  return (
    <section
      data-testid="printing-tech-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <h2
              data-testid="printing-tech-heading"
              className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold text-coastal-navy mb-6"
            >
              We bring your designs to life with{' '}
              <span className="text-coastal-orange">care and innovation</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              Coastal Route combines premium materials and state-of-the-art
              production processes to ensure exceptional quality garments at
              every step.
            </p>

            {/* Technology List */}
            <div
              data-testid="tech-list"
              className="space-y-6"
            >
              {technologies.map((tech, index) => {
                const Icon = tech.icon;

                return (
                  <div
                    key={index}
                    data-testid={`tech-${index}`}
                    className="flex gap-4"
                  >
                    <div className="flex-shrink-0 w-14 h-14 bg-coastal-offwhite rounded-2xl flex items-center justify-center">
                      <Icon className="w-7 h-7 text-coastal-orange" />
                    </div>
                    <div>
                      <h3 className="font-heading font-semibold text-coastal-navy text-lg mb-1">
                        {tech.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {tech.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right - Image */}
          <div
            data-testid="printing-tech-image"
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1758183961426-88d64eb5f787?w=800&h=600&fit=crop"
                alt="Industrial printing press"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Quality Badge */}
            <div className="absolute -bottom-4 -left-4 bg-coastal-navy text-white rounded-2xl p-5 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-coastal-orange"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="font-heading font-bold text-lg">99% Quality</p>
                  <p className="text-white/60 text-sm">Satisfaction Rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrintingTech;
